import { render, staticRenderFns } from "./PhoneVerificationCode.vue?vue&type=template&id=b12662ee&scoped=true"
import script from "./PhoneVerificationCode.vue?vue&type=script&lang=js"
export * from "./PhoneVerificationCode.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerificationCode.vue?vue&type=style&index=0&id=b12662ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12662ee",
  null
  
)

export default component.exports